/* eslint-disable */
// @ts-nocheck
/**
 * @fileoverview gRPC-Web generated client stub for worklayer.internal.v1
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v3.19.1
// source: internal/consultation.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')

var google_protobuf_duration_pb = require('google-protobuf/google/protobuf/duration_pb.js')

var shared_types_interval_pb = require('../shared/types/interval_pb.js')
const proto = {};
proto.worklayer = {};
proto.worklayer.internal = {};
proto.worklayer.internal.v1 = require('./consultation_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.worklayer.internal.v1.ConsultationServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.worklayer.internal.v1.ConsultationServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.SetConsultationAvailabilityRequest,
 *   !proto.worklayer.internal.v1.SetConsultationAvailabilityResponse>}
 */
const methodDescriptor_ConsultationService_SetConsultationAvailability = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.ConsultationService/SetConsultationAvailability',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.SetConsultationAvailabilityRequest,
  proto.worklayer.internal.v1.SetConsultationAvailabilityResponse,
  /**
   * @param {!proto.worklayer.internal.v1.SetConsultationAvailabilityRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.SetConsultationAvailabilityResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.SetConsultationAvailabilityRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.SetConsultationAvailabilityResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.SetConsultationAvailabilityResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.ConsultationServiceClient.prototype.setConsultationAvailability =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.ConsultationService/SetConsultationAvailability',
      request,
      metadata || {},
      methodDescriptor_ConsultationService_SetConsultationAvailability,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.SetConsultationAvailabilityRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.SetConsultationAvailabilityResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.ConsultationServicePromiseClient.prototype.setConsultationAvailability =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.ConsultationService/SetConsultationAvailability',
      request,
      metadata || {},
      methodDescriptor_ConsultationService_SetConsultationAvailability);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.ListBookedConsultationsRequest,
 *   !proto.worklayer.internal.v1.ListBookedConsultationsResponse>}
 */
const methodDescriptor_ConsultationService_ListBookedConsultations = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.ConsultationService/ListBookedConsultations',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.ListBookedConsultationsRequest,
  proto.worklayer.internal.v1.ListBookedConsultationsResponse,
  /**
   * @param {!proto.worklayer.internal.v1.ListBookedConsultationsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.ListBookedConsultationsResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.ListBookedConsultationsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.ListBookedConsultationsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.ListBookedConsultationsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.ConsultationServiceClient.prototype.listBookedConsultations =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.ConsultationService/ListBookedConsultations',
      request,
      metadata || {},
      methodDescriptor_ConsultationService_ListBookedConsultations,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.ListBookedConsultationsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.ListBookedConsultationsResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.ConsultationServicePromiseClient.prototype.listBookedConsultations =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.ConsultationService/ListBookedConsultations',
      request,
      metadata || {},
      methodDescriptor_ConsultationService_ListBookedConsultations);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.BookConsultationRequest,
 *   !proto.worklayer.internal.v1.BookConsultationResponse>}
 */
const methodDescriptor_ConsultationService_BookConsultation = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.ConsultationService/BookConsultation',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.BookConsultationRequest,
  proto.worklayer.internal.v1.BookConsultationResponse,
  /**
   * @param {!proto.worklayer.internal.v1.BookConsultationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.BookConsultationResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.BookConsultationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.BookConsultationResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.BookConsultationResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.ConsultationServiceClient.prototype.bookConsultation =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.ConsultationService/BookConsultation',
      request,
      metadata || {},
      methodDescriptor_ConsultationService_BookConsultation,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.BookConsultationRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.BookConsultationResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.ConsultationServicePromiseClient.prototype.bookConsultation =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.ConsultationService/BookConsultation',
      request,
      metadata || {},
      methodDescriptor_ConsultationService_BookConsultation);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.UnbookConsultationRequest,
 *   !proto.worklayer.internal.v1.UnbookConsultationResponse>}
 */
const methodDescriptor_ConsultationService_UnbookConsultation = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.ConsultationService/UnbookConsultation',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.UnbookConsultationRequest,
  proto.worklayer.internal.v1.UnbookConsultationResponse,
  /**
   * @param {!proto.worklayer.internal.v1.UnbookConsultationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.UnbookConsultationResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.UnbookConsultationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.UnbookConsultationResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.UnbookConsultationResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.ConsultationServiceClient.prototype.unbookConsultation =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.ConsultationService/UnbookConsultation',
      request,
      metadata || {},
      methodDescriptor_ConsultationService_UnbookConsultation,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.UnbookConsultationRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.UnbookConsultationResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.ConsultationServicePromiseClient.prototype.unbookConsultation =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.ConsultationService/UnbookConsultation',
      request,
      metadata || {},
      methodDescriptor_ConsultationService_UnbookConsultation);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.DownloadConsultationCalendarRequest,
 *   !proto.worklayer.internal.v1.DownloadConsultationCalendarResponse>}
 */
const methodDescriptor_ConsultationService_DownloadConsultationCalendar = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.ConsultationService/DownloadConsultationCalendar',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.DownloadConsultationCalendarRequest,
  proto.worklayer.internal.v1.DownloadConsultationCalendarResponse,
  /**
   * @param {!proto.worklayer.internal.v1.DownloadConsultationCalendarRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.DownloadConsultationCalendarResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.DownloadConsultationCalendarRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.DownloadConsultationCalendarResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.DownloadConsultationCalendarResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.ConsultationServiceClient.prototype.downloadConsultationCalendar =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.ConsultationService/DownloadConsultationCalendar',
      request,
      metadata || {},
      methodDescriptor_ConsultationService_DownloadConsultationCalendar,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.DownloadConsultationCalendarRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.DownloadConsultationCalendarResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.ConsultationServicePromiseClient.prototype.downloadConsultationCalendar =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.ConsultationService/DownloadConsultationCalendar',
      request,
      metadata || {},
      methodDescriptor_ConsultationService_DownloadConsultationCalendar);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.v1.ListBookedTimeRangesForProRequest,
 *   !proto.worklayer.internal.v1.ListBookedTimeRangesForProResponse>}
 */
const methodDescriptor_ConsultationService_ListBookedTimeRangesForPro = new grpc.web.MethodDescriptor(
  '/worklayer.internal.v1.ConsultationService/ListBookedTimeRangesForPro',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.v1.ListBookedTimeRangesForProRequest,
  proto.worklayer.internal.v1.ListBookedTimeRangesForProResponse,
  /**
   * @param {!proto.worklayer.internal.v1.ListBookedTimeRangesForProRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.v1.ListBookedTimeRangesForProResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.v1.ListBookedTimeRangesForProRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.v1.ListBookedTimeRangesForProResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.v1.ListBookedTimeRangesForProResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.v1.ConsultationServiceClient.prototype.listBookedTimeRangesForPro =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.v1.ConsultationService/ListBookedTimeRangesForPro',
      request,
      metadata || {},
      methodDescriptor_ConsultationService_ListBookedTimeRangesForPro,
      callback);
};


/**
 * @param {!proto.worklayer.internal.v1.ListBookedTimeRangesForProRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.v1.ListBookedTimeRangesForProResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.v1.ConsultationServicePromiseClient.prototype.listBookedTimeRangesForPro =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.v1.ConsultationService/ListBookedTimeRangesForPro',
      request,
      metadata || {},
      methodDescriptor_ConsultationService_ListBookedTimeRangesForPro);
};


module.exports = proto.worklayer.internal.v1;

